import React, {useState} from "react";
import WeatherForecast from "./WeatherForecast"
import WeatherInfo from "./WeatherInfo";
import axios from "axios";
import "./Weather.css"
export default function Weather(props){
    const [city,setCity]=useState(props.defaultCity)
    const [weatherData,setWeatherData]=useState({ready:false});
    
    function handleResponse (response){
    console.log(response.data )  
    setWeatherData({
        ready:true,
        coordinates:response.data.coord,
        temperature:response.data.main.temp,
        date:new Date(response.data.dt*1000),
        description:response.data.weather[0].description,
        humidity:response.data.main.humidity,
        wind:response.data.wind.speed,
        city:response.data.name,
        icon :response.data.weather[0].icon,
    }) 
}
function search(){
    let apiKey="3a94f3778290bfeee61278505dbbe51d";
    let url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(url).then(handleResponse)
}
function handleSubmit(event){
    event.preventDefault()
    search()
}
function handleCityChange(event){
setCity(event.target.value)
}
    if(weatherData.ready){
        return(
            <div className="Weather">
             <form onSubmit={handleSubmit}>
                 <div className="row">
                 <div className="col-9">
                 <input onChange={handleCityChange} type="search" placeholder="Enter a city..." autoFocus="on" className="form-control"/>
                 </div>
                 <div className="col-3">
                 <input type="submit" value="Search" className="btn btn-primary w-100" />
             </div>
             </div>
             </form>
             <WeatherInfo data={weatherData}/>
             <WeatherForecast coordinates={weatherData.coordinates}/>
             </div>
             );
    }else{
        search()
        return"Loading...."
    }




   

}
